<script>

    import { toast } from 'bulma-toast'

    import UsersService from '../$services/users.service'
    import Form from '../$components/form.svelte'
    import Button from '../$components/button.svelte'

    let loading = false
    let element = null

    async function getUsersReport() {

        loading = true
        const blob = await UsersService.getUsersReport()
        loading = false

        if(!blob)
            return toast({message: 'Error al descargar el reporte', type: 'is-danger'})

        element.download = 'reporte_usuarios.xlsx'
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

</script>

<a bind:this={element} href="/" style="display: none;">.</a>

<Form on:submit={getUsersReport} { loading }>
    <Button type="submit" text="Descargar" icon="file-download" { loading } />
</Form>
